import { IconBoard } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

export const dashboardModule: ModuleDefinition = {
  id: 'dashboard',
  i18nNamespace: 'dashboard',
  requires: { subject: 'business', action: 'read' },

  nav: {
    labelKey: 'dashboard:title',
    icon: IconBoard,
    to: '',
    group: 'trade',
    order: 0,
  },

  routes: [{ path: '/', component: () => import('./DashboardPage') }],
};
